import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './agreement.reducer';

export const AgreementDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const agreementEntity = useAppSelector(state => state.agreement.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="agreementDetailsHeading">
          <Translate contentKey="crawlerBackendApp.agreement.detail.title">Agreement</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{agreementEntity.id}</dd>
          <dt>
            <span id="effectiveDate">
              <Translate contentKey="crawlerBackendApp.agreement.effectiveDate">Effective Date</Translate>
            </span>
          </dt>
          <dd>
            {agreementEntity.effectiveDate ? (
              <TextFormat value={agreementEntity.effectiveDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="expirationDate">
              <Translate contentKey="crawlerBackendApp.agreement.expirationDate">Expiration Date</Translate>
            </span>
          </dt>
          <dd>
            {agreementEntity.expirationDate ? (
              <TextFormat value={agreementEntity.expirationDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="crawlerBackendApp.agreement.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>
            {agreementEntity.endDate ? (
              <TextFormat value={agreementEntity.endDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="contractType">
              <Translate contentKey="crawlerBackendApp.agreement.contractType">Contract Type</Translate>
            </span>
          </dt>
          <dd>{agreementEntity.contractType}</dd>
          <dt>
            <span id="createdTimestamp">
              <Translate contentKey="crawlerBackendApp.agreement.createdTimestamp">Created Timestamp</Translate>
            </span>
          </dt>
          <dd>
            {agreementEntity.createdTimestamp ? (
              <TextFormat value={agreementEntity.createdTimestamp} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="status">
              <Translate contentKey="crawlerBackendApp.agreement.status">Status</Translate>
            </span>
          </dt>
          <dd>{agreementEntity.status}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.agreement.customerOrder">Customer Order</Translate>
          </dt>
          <dd>{agreementEntity.customerOrder ? agreementEntity.customerOrder.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/agreement" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/agreement/${agreementEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AgreementDetail;
